export const SPECIAL_REQUESTS_STATE = 'specialRequests'

export const SPECIAL_REQUESTS_REQUEST = 'SPECIAL_REQUESTS_REQUEST'
export const SPECIAL_REQUESTS_SUCCESS = 'SPECIAL_REQUESTS_SUCCESS'
export const SPECIAL_REQUESTS_FAILURE = 'SPECIAL_REQUESTS_FAILURE'

export const STATUS_OK = 'STATUS_OK'
export const STATUS_NOT_OK = 'STATUS_NOT_OK'
